import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {
    filterSingleDate_template
} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template';
import {
    validationsList_template
} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template';
import {transactionsComparison_template} from './transactionsComparison_template';
import {transactionTimePeriod_template} from './transactionsTimePeriod_template';
import EntryType from "../../utils/EntryType";
import ItemType from "../../utils/ItemType";

declare var ko: any;

export class transactionsEdit_template extends vnTemplate {

    public datePicker: filterSingleDate_template;
    public comparisonTransactions: transactionsComparison_template;
    protected validationsList: validationsList_template;
    public transactionTimePeriod: transactionTimePeriod_template;
    public splitTimePeriod: transactionTimePeriod_template;
    private allowedPayrollEntryTypes = [3,4,9,10];
    private allowedNonPayrollEntryTypes = [1,2,3,4,5,6,7,8,11,12];
    private allowedPayrollItemTypes = [4,5,6,7];
    private allowedNonPayrollItemTypes = [1,2,3,4,5,6,7,8,9,10,11,12];

    protected getTemplateHtml(): string {

        return this.validationsList.getHtmlBuild() + `

                <div class="double-list-header" data-bind="visible: isPaid">
                   <h3 class="double-list-title i-transaction">Edit Paid Transaction</h3>
                   <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2"><span class="hidden-text">close</span></button>
                </div>
                
                ${ this.comparisonTransactions.getHtmlBuild() }
                
                <div class="form-header">
                    <input id="user-id" data-bind="value: id" type="hidden">
                    <h3 class="form-title icon i-transaction"><span data-bind="text:infoTitle"> </span> <span style="display: inline-block;margin-left: .25rem">Transaction</span></h3>
                    <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2" type="button"></button>
                </div>
                <div class="w-form-body" data-bind="css: { 'margin-top': isPaid}">
                    <div class="form-body">
                        
                        <strong class="form-sub-title">Information</strong>
                        <!--
                         <div class="form-group">
                            <label class="form-label" for="name">Name <span>(auto generated)</span></label>
                            <input id="name" disabled data-bind="value: name" type="text" class="input-text">
                        </div>
                        -->
                        <div class="form-group read-only vertical">
                            <label for="name" class="form-label">Name</label>
                            <span data-bind="text: name"></span>
                        </div>
                        
                         <div class="form-group row">
                            <label for="type" class="form-label">status</label>
                            <select id="type" data-bind="options: options_status, value: idStatus, optionsText: 'name', optionsValue: 'id', optionsCaption: 'Select', valueAllowUnset: true">
                            </select>
                        </div>
                        
                        <div class="form-group icon i-auto-complete">
                            <label class="form-label" for="idUser">user</label>
                            <input id="idUser" autocomplete="off" data-bind="event: { input: onChangeUserInput }, textInput: user, valueUpdate : 'input'" list="users" class="input-text">
                                <ul class="form-auto-list" data-bind="foreach: users, visible: isShowUserSuggestions" id="users">
                                    <li class="form-auto-item" data-bind="attr:{id:id}, text: $data.valnet_user.fullNameAndLogin, click: $parent.onBlurUser" ></li>
                                </ul>
                            </input>
                        </div>
                        
                         <div class="form-group row">
                            <label for="type" class="form-label">account</label>
                            <select id="type" data-bind="options: options_accounts, value: idAccount, optionsText: 'name', optionsValue: 'id', optionsCaption: 'Select', valueAllowUnset: true, disable: disableAccount">
                            </select>
                        </div>
    
                       
                        <div class="form-group row">
                            <label for="entryType" class="form-label">entry type</label>
                            <select id=entryType" data-bind="options: options_entryTypes, value: idEntryType, optionsText: 'name', optionsValue: 'id', optionsCaption: 'Select', valueAllowUnset: true, disable: disableEntryTypes, event: {change : onEntryTypeChange}">
                            </select>
                        </div>
                        
                        
                        <div class="form-group row">
                            <label for="itemType" class="form-label">item type</label>
                            <select id="itemType" style="width:100%;" data-bind="options: options_itemTypes, value: idItemType, optionsText: 'name', optionsValue: 'id', optionsCaption: 'Select', valueAllowUnset: true, disable: disableItemType">
                            </select>
                        </div>
                        
                        <div data-bind="visible: idItemType() == 6 || idItemType() == 11 ">
                            ${this.transactionTimePeriod.getHtmlBuild()}
                        </div>
                        
                    
                        <div class="form-group" data-bind="visible: idItemType() == 12 ">
                            <label for="salaryType" class="form-label">Article Group<span>*</span></label>
                            <select id="salaryType" data-bind="options: options_articleGroups, value: idItem, optionsCaption: 'Select', optionsText: function(item) { return item.dateStart + ' - ' + item.dateEnd; }, optionsValue: 'id', valueAllowUnset: true">
                            </select>
                        </div>
                        
                        <div class="form-group" data-bind="visible: idItemType() == 1 || idItemType() == 8 || idItemType() == 9">
                            <label class="form-label" for="idArticle">Article<span>*</span></label>
                            <input id="idArticle" autocomplete="off" data-bind="event: { input: onChangeArticleInput },value: article, valueUpdate : 'afterkeydown', disable: isEdit" list="articles" class="input-text">
                                <ul class="form-auto-list" data-bind="foreach: articles, visible: isShowArticleSuggestions" id="articles">
                                    <li class="form-auto-item" data-bind="attr:{id:id}, text: $data.title, click: $parent.onBlurArticle" ></li>
                                </ul>
                            </input>
                            <small class="form-error"></small>
                        </div>
                        
                        <div class="form-group" data-bind="visible: idItemType() == 9">
                            <label class="form-label" for="idOutreachArticle">Republish<span>*</span></label>
                            <select id="type" data-bind="options: options_republishes, value: idItem, optionsText: 'dateRepublished', optionsValue: 'id', optionsCaption: 'Select', valueAllowUnset: true, disable: isEdit">
                            </select>
                            </input>
                            <small class="form-error"></small>
                        </div>
                        
                        <div class="form-group" data-bind="visible: idItemType() == 3">
                            <label class="form-label" for="idOutreachArticle">Outreach Article<span>*</span></label>
                            <input id="idOutreachArticle" autocomplete="off" data-bind="event: { input: onChangeOutreachArticleInput },value: outreachArticle, valueUpdate : 'afterkeydown', disable: isEdit" list="outreachArticles" class="input-text">
                                <ul class="form-auto-list" data-bind="foreach: outreachArticles, visible: isShowOutreachArticleSuggestions" id="outreachArticles">
                                    <li class="form-auto-item" data-bind="attr:{id:id}, text: $data.title, click: $parent.onBlurOutreachArticle" ></li>
                                </ul>
                            </input>
                            <small class="form-error"></small>
                        </div>
                        
                        <div class="form-group">
                            <label class="form-label" for="note">Note</label>
                            <input id="note" maxlength="100" data-bind="value: note" type="text" class="input-text">
                            <small class="form-error"></small>
                        </div>
                        
                    </div>
                    
                    <div class="form-body">
                        <strong class="form-sub-title">Settings</strong>
                        
                        <div class="form-group row">
                            <label for="idRole" class="form-label">Role</label>
                            <select id="idRole" style="width:100%;" data-bind="options: options_roles, optionsText: 'name', value: idRole, optionsValue: 'id', optionsCaption: 'Select', valueAllowUnset: true">
                            </select>
                        </div>
                        
                        <div class="form-group row">
                            <label for="type" class="form-label">type</label>
                            <select id="type" data-bind="options: options_types, value: idType, optionsText: function (item) { return item.name + ' - ' + item.description }, optionsValue: 'id', optionsCaption: 'Select', valueAllowUnset: true">
                            </select>
                        </div>
                        
                        <div class="form-group">
                            <label class="form-label" for="amount">Amount</label>
                            <input id="amount" data-bind="value: amount" type="text" class="input-text">
                            <small class="form-error"></small>
                        </div>
                        
                         <!-- ko if: requiresBrandSplit() == true -->
                         <div class="form-group row" >

                             <div class="w-add-rec-trans dropdown">
                               
                                
                                <button type="button" class="btn border dropdown-toggle icon i-dropdown-simple" data-bind="event: { mouseover: showBrandSelector, mouseout: hideBrandSelector }">Brands</button>
                                <div class="add-rec-trans is-visible" data-bind="foreach: brands, visible: isBrandSelectorShown, event: { mouseover: showBrandSelector, mouseout: hideBrandSelector }">
                                <!-- is-visible -->                                                               
                                    <div class="form-group row">
                                        <input data-bind="value: id, checked: checked, attr:{id: 'brand_' + id}" type="checkbox">
                                        <label class="form-label icon i-check" data-bind="text: name, attr:{for: 'brand_' + id}"></label>
                                        <input class="input-text long" type="text" data-bind="value: amount">
                                        <span>$</span>
                                    </div>     
                                </div>
                             </div>
                        </div>   
                         <!-- /ko -->
                        
                       
           
                        
                        <div class="form-group row" data-bind="visible:false">
                            <label for="actionType" class="form-label">action type</label>
                            <select id="actionType" disabled="true" data-bind="options: options_actionTypes, value: idActionType, optionsText: 'name', optionsValue: 'id', optionsCaption: 'Select', valueAllowUnset: true">
                            </select>
                        </div>
    
                        <div class="form-group row" data-bind="visible:false">
                            <label for="creationType" class="form-label">creation type</label>
                            <select id="creationType" disabled="true" data-bind="options: options_creationTypes, value: idCreationType, optionsText: 'name', optionsValue: 'id', optionsCaption: 'Select', valueAllowUnset: true">
                            </select>
                        </div>
                                               
                        <div class="form-group row" data-bind="visible:false">
                            <label for="currency" class="form-label">Currency</label>
                            <select id="currency" disabled="true" data-bind="options: options_currencies, value: idCurrency, optionsText: 'currency', optionsValue: 'id', optionsCaption: 'Determined by User Selection', valueAllowUnset: true">
                            </select>
                        </div>
                        
                         
                        
                        <!-- ko if: requiresBrandSplit() == true -->
                        <div class="form-group row">
                            <input data-bind="value: valnetSupportSplit, checked: valnetSupportSplit, event: {change: onChangeResetBrandSplit }" type="checkbox" id="valnetSupportSplit">
                            <label class="form-label icon i-check" for="valnetSupportSplit">Valnet Support Split</label>
                        </div>
                        
                        <div data-bind="visible: valnetSupportSplit()">
                            ${this.splitTimePeriod.getHtmlBuild()}
                        </div>
                        
                        <div class="form-group">
                            <button type="button" class="btn border" data-bind="event: { click: onClickFillBrandSplit }, visible: valnetSupportSplit, css: {'is-disable' : !enableSplitButton() }">Fill Brand Splits</button>
                        </div>
                        
                        
                        <!-- /ko -->


                        <div class="form-group row">
                            <label for="singleDatePicker" class="form-label">schedule date</label>
                            ` + this.datePicker.getHtmlBuild() + `
                        </div>
                        
                        <div class="form-group read-only">
                            <label for="payment" class="form-label">action type</label>
                            <span data-bind="text: actionType"></span>
                        </div>
                        
                        <div class="form-group read-only">
                            <label for="payment" class="form-label">creation type</label>
                            <span data-bind="text: creationType"></span>
                        </div>
                        
                        <div class="form-group read-only">
                            <label for="payment" class="form-label">Created By</label>
                            <span data-bind="text: creator"></span>
                        </div>
                         <div class="form-group read-only">
                            <label for="payment" class="form-label">currency</label>
                            <span data-bind="text: currency"></span>
                        </div>                        
                        <div class="form-group read-only">
                            <label for="payment" class="form-label">payment date</label>
                            <span data-bind="text: paymentDate"></span>
                        </div>
                     
                    </div>
                </div>
                
                <div class="form-footer">
                    <button data-bind="event: { click: onClickCancel }" class="btn" type="button">Cancel</button>
                    <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button> 
                </div>
   
            `;
    }

    protected initPartial(): void {
        this.datePicker = new filterSingleDate_template("filterDate", this.getTemplateViewModel(), this.caller);
        this.comparisonTransactions = new transactionsComparison_template("comparisonTransactions", this.getTemplateViewModel(), this.caller);
        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);
        this.transactionTimePeriod = new transactionTimePeriod_template('transactionTimePeriod', this.getTemplateViewModel(), this.caller);
        this.transactionTimePeriod.setYearsBack(3);
        this.transactionTimePeriod.setYearsAhead(2);
        this.transactionTimePeriod.initData();
        this.splitTimePeriod = new transactionTimePeriod_template('splitTimePeriod', this.getTemplateViewModel(), this.caller);
        this.splitTimePeriod.setAsDynamic(true);
        this.splitTimePeriod.setYearsBack(3);
        this.splitTimePeriod.initData();
    }

    protected getTemplateName(): string {
        return "transactionEdit-template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-double-list"];
    }

    public buildDatePickerCalendar() {
        this.datePicker.buildCalendar();
    }

    protected buildViewModel(): any {

        let self = this;
        return {
            id: ko.observable(""),
            isEdit: ko.observable(false),
            amount: ko.observable(""),
            name: ko.observable(""),
            note: ko.observable(""),
            paymentDate: ko.observable(""),
            idPayment: ko.observable(""),
            actionType: ko.observable(""),
            creationType: ko.observable(""),
            currency: ko.observable(""),
            options_status: ko.observable([]),
            idStatus: ko.observable(),
            options_roles: ko.observableArray([]),
            idRole: ko.observable(),
            options_currencies: ko.observableArray([]),
            idCurrency: ko.observable(),
            enableSplitButton: ko.observable(),
            options_accounts: ko.observableArray([]),
            options_all_accounts: ko.observableArray([]),
            idAccount: ko.observable(),
            disableAccount: ko.observable(false),
            options_actionTypes: ko.observableArray([]),
            idActionType: ko.observable(),
            options_types: ko.observableArray([]),
            idType: ko.observable(),
            options_creationTypes: ko.observableArray([]),
            idCreationType: ko.observable(),
            options_entryTypes: ko.observableArray([]),
            options_all_entryTypes: ko.observableArray([]),
            idEntryType: ko.observable(),
            entryTypes: ko.observableArray([]),
            disableEntryTypes: ko.observable(true),
            options_itemTypes: ko.observableArray([]),
            options_itemTypes_clone: ko.observableArray([]),
            options_all_itemTypes: ko.observableArray([]),
            idItemType: ko.observable(""),
            disableItemType: ko.observable(true),
            options_periods: ko.observableArray([]),
            options_articleGroups: ko.observableArray([]),
            idItem: ko.observable(null),
            article: ko.observable(),
            articles: ko.observableArray([]),
            outreachArticle: ko.observable(),
            outreachArticles: ko.observableArray([]),
            options_republishes: ko.observableArray([]),
            idUser: ko.observable(null),
            idUserPaymentClassification: ko.observable(null),
            userPaymentClassificationEffectiveDate: ko.observable(null),
            user: ko.observable(""),
            users: ko.observableArray([]),
            infoTitle: ko.observable("Edit"),
            isPaid: ko.observable(false),
            valnetSupportSplit: ko.observable(false),
            channels: ko.observableArray([]),
            idChannel: ko.observable(""),
            isShowUserSuggestions: ko.observable(false),
            isShowArticleSuggestions: ko.observable(false),
            isShowOutreachArticleSuggestions: ko.observable(false),
            requiresBrandSplit: ko.observable(false),
            brands: ko.observableArray([]),
            allBrands: ko.observableArray([]),
            selectedBrands: ko.observableArray([]),
            selectedBrandsPercentages: ko.observableArray([]),
            isBrandSelectorShown: ko.observable(false),
            creator: ko.observable(''),
            entryTypesRules: ko.observable(undefined),
            onBlurUser: function (data, event) {
                self.onBlurUser(data, event);
            },
            onBlurArticle: function (data, event) {
                self.onBlurArticle(data, event);
            },
            onBlurOutreachArticle: function (data, event) {
                self.onBlurOutreachArticle(data, event);
            },
            onChangeChannel: function (data, event) {
                self.onChangeChannel();
            },
            onChangeUserInput: function (data, event) {
                self.onChangeUserInput(event);
            },
            onChangeArticleInput: function (data, event) {
                self.onChangeArticleInput(event);
            },
            onChangeOutreachArticleInput: function (data, event) {
                self.onChangeOutreachArticleInput(event);
            },
            onClickSave: function (data, event) {
                self.onClickSave();
            },
            onClickCancel: function (data, event) {
                self.onClickCancel();
            },
            showBrandSelector: function (data, event) {
                self.setIsBrandSelectorShown(true);
            },
            hideBrandSelector: function (data, event) {
                self.setIsBrandSelectorShown(false);
            },
            onChangeResetBrandSplit: function (data, event) {
                self.onChangeResetBrandSplit();
            },
            onClickFillBrandSplit: function (data, event) {
                self.onClickFillBrandSplit();
            },

            onEntryTypeChange: function (data) {
                self.onEntryTypeChange(data);
            }
        };
    }



    public setRequiresBrandSplit(requiresBrandSplit) {

        this.getTemplateViewModel().requiresBrandSplit(requiresBrandSplit);
    }

    public setCreationTypes(creationTypes: Array<any>) {

        this.getTemplateViewModel().options_creationTypes(creationTypes);
    }

    public setTypes(types: Array<any>) {

        this.getTemplateViewModel().options_types(types);
    }

    public setActionTypes(actionTypes: Array<any>) {

        this.getTemplateViewModel().options_actionTypes(actionTypes);
    }

    public setAccounts(accounts: Array<any>) {

        this.getTemplateViewModel().options_accounts(accounts);
    }

    public setAllAccounts(accounts: Array<any>) {

        this.getTemplateViewModel().options_all_accounts(accounts);
    }

    public setEntryTypeOptions(entryTypes: Array<any>) {

        this.getTemplateViewModel().options_entryTypes(entryTypes);
    }

    public setAllEntryTypeOptions(entryTypes: Array<any>) {

        this.getTemplateViewModel().options_all_entryTypes(entryTypes);
    }

    public setRoles(roles: Array<any>) {

        this.getTemplateViewModel().options_roles(roles);
    }

    public setEntryTypes(entryTypes: Array<any>) {

        this.getTemplateViewModel().entryTypes(entryTypes);
    }

    public setItemTypes(itemTypes: Array<any>) {

        this.getTemplateViewModel().options_itemTypes(itemTypes);
        this.getTemplateViewModel().options_itemTypes_clone(itemTypes);
    }

    public setAllItemTypes(itemTypes: Array<any>) {

        itemTypes = itemTypes.filter(function(value, index, arr){
            return value.id != 11;
        });

        this.getTemplateViewModel().options_all_itemTypes(itemTypes);
    }


    public setChannels(channels: Array<any>) {

        this.getTemplateViewModel().channels(channels);
    }

    public setValnetSupportSplit(valnetSupportSplit: boolean) {

        this.getTemplateViewModel().valnetSupportSplit(valnetSupportSplit);
    }

    public setCurrencies(currencies: Array<any>) {

        this.getTemplateViewModel().options_currencies(currencies);
    }

    public setStatus(status: Array<any>) {

        this.getTemplateViewModel().options_status(status);
    }

    public setUsers(users: Array<any>) {
        this.getTemplateViewModel().users(users);
    }

    public setArticles(articles: Array<any>) {

        // TODO : for now we check it like this
        if( articles && articles[0] ){

            this.getTemplateViewModel().articles(articles);
        }
        else{

            this.getTemplateViewModel().articles(null);
        }
    }

    public setOutreachArticles(outreachArticles: Array<any>) {

        this.getTemplateViewModel().outreachArticles(outreachArticles);
    }


    protected onClickSave() {
        this.caller.saveEditTransaction();
    }

    protected onClickCancel() {
        this.caller.cancelEditTransaction();
    }

    public setComparisonTransactions(trx, reverseTrx, data) {
        if (trx) {
            this.comparisonTransactions.setOriginalTrx(trx, data);
        }

        if (reverseTrx) {
            this.comparisonTransactions.setReverseTrx(reverseTrx, data);
        }
    }


    public showComparisonTrx() {
        this.comparisonTransactions.showComparison();
    }

    public showReversalTrx() {
        this.comparisonTransactions.showReversal();
    }

    public filterRoles() {
        let idChannel = this.getTemplateViewModel().idChannel();
        let channels = this.getTemplateViewModel().channels();
        let idRole = this.getTemplateViewModel().idRole();
        let paymentRoles = [];

        let selectedChannel = channels.find(c => c.id == idChannel);
        if (selectedChannel != null) {
            for (let paymentRole of selectedChannel.paymentRoles) {
                paymentRoles.push(paymentRole.role);
            }
            let selectedRole = paymentRoles.find(r => r.id == idRole);
            if (selectedRole == null) {
                this.getTemplateViewModel().idRole(null);
            }
            paymentRoles.sort(this.compare);
            this.getTemplateViewModel().options_roles(paymentRoles);
        }
    }

    private compare(a, b) {
        if (a.name < b.name)
            return -1;
        if (a.name > b.name)
            return 1;
        return 0;
    }

    //
    // set selection functions
    //
    public setSelectedUser(idUser: number, selectedItemType: number) {

        if (idUser) {
            let user = this.getSelectAvailableString(idUser, this.getTemplateViewModel().users());
            this.getTemplateViewModel().user(user.valnet_user.fullNameAndLogin);
            this.getTemplateViewModel().idUser(user.id);
            this.getTemplateViewModel().idUserPaymentClassification(user.idPaymentClassification);
            this.getTemplateViewModel().userPaymentClassificationEffectiveDate(user.effectiveDate);
            let effectiveDate = new Date(user.effectiveDate);
            let entryTypes: any[];
            let itemTypes: any[];
            let accounts = [];
            let moi = this;

            if(user.idPaymentClassification == 2 && effectiveDate <= new Date()){

                entryTypes = this.getTemplateViewModel().options_all_entryTypes().filter(function (entry){
                    return moi.allowedPayrollEntryTypes.indexOf(entry.id) >= 0;
                });
                itemTypes = this.getTemplateViewModel().options_all_itemTypes().filter(function (entry){
                    return moi.allowedPayrollItemTypes.indexOf(entry.id) >= 0;
                });
                if(!this.getTemplateViewModel().id()) {
                    accounts = this.getTemplateViewModel().options_all_accounts().filter(function (entry) {
                        return entry.id == 4;
                    });
                }
            } else {

                let allowedNonPayrollItemTypes = this.getItemTypeIdsToInclude(selectedItemType);

                entryTypes = this.getTemplateViewModel().options_all_entryTypes().filter(function (entry){
                    return moi.allowedNonPayrollEntryTypes.indexOf(entry.id) >= 0;
                });
                itemTypes = this.getTemplateViewModel().options_all_itemTypes().filter(function (entry){
                    return allowedNonPayrollItemTypes.indexOf(entry.id) >= 0;
                });
                if(!this.getTemplateViewModel().id()) {
                    accounts = this.getTemplateViewModel().options_all_accounts().filter(function (entry) {
                        return entry.id != 4;
                    });
                }
            }
            this.getTemplateViewModel().options_entryTypes(entryTypes);
            this.getTemplateViewModel().options_itemTypes(itemTypes);
            this.getTemplateViewModel().options_itemTypes_clone(itemTypes);
            if(accounts.length > 0) {
                this.getTemplateViewModel().options_accounts(accounts);
            } else {
                this.getTemplateViewModel().options_accounts(this.getTemplateViewModel().options_all_accounts());
            }
            this.limitBrandByCompany(user);
        }
    }

    public setSelectedItem(idItem) {

        let foundArticle = this.getSelectAvailableString(idItem, this.getTemplateViewModel().articles());
        if (foundArticle) {
            this.getTemplateViewModel().article(foundArticle.title);
        }
        this.getTemplateViewModel().idItem(idItem);
    }

    public setTrxId(idTransaction: number) {
        this.getTemplateViewModel().id(idTransaction);
    }

    protected getSelectAvailableString(id: number, list: any) {
        let found = false;
        if (Array.isArray(list)) {

            for (let c of list) {
                if (c.id == id) {
                    found = true;
                    return c;
                }
            }
        }
        if (!found) {
            return " *Not available anymore*";
        }
        return "";
    }

    public setBrandOptions(brands) {

        this.getTemplateViewModel().brands(brands);
    }

    public setAllBrands(brands) {

        this.getTemplateViewModel().allBrands(brands);
        this.limitBrandByCompany(null);
    }

    public setArticleGroups(articleGroups: Array<any>) {

        this.getTemplateViewModel().options_articleGroups(articleGroups);
    }


    public setSelectedCreationType(selectedCreationType: number) {

        let creationTypeName = this.getTemplateViewModel().options_creationTypes().find(item => item.id === selectedCreationType).name;
        this.getTemplateViewModel().creationType(creationTypeName);
        this.getTemplateViewModel().idCreationType(selectedCreationType);
    }

    public setSelectedType(selectedType: number) {

        this.getTemplateViewModel().idType(selectedType);
    }

    public setSelectedActionType(selectedActionType: number) {

        let actionTypeName = this.getTemplateViewModel().options_actionTypes().find(item => item.id === selectedActionType).name;
        this.getTemplateViewModel().actionType(actionTypeName);
        this.getTemplateViewModel().idActionType(selectedActionType);
    }

    public setSelectedEntryType(selectedEntryType: number) {

        this.getTemplateViewModel().idEntryType(selectedEntryType);
    }

    public setSelectedAccount(selectedAccount: number) {

        this.getTemplateViewModel().idAccount(selectedAccount);

        let entryTypes = this.getTemplateViewModel().options_all_entryTypes();
        let itemTypes = this.getTemplateViewModel().options_all_itemTypes();
        let allAccounts = this.getTemplateViewModel().options_all_accounts();
        let accountOptions =  allAccounts.filter((account) => account.id != 4);

        let selectableIdEntryTypes = [
            EntryType.COMMISSION, EntryType.PERFORMANCE, EntryType.BONUS, EntryType.TIPS,
            EntryType.HOSTING, EntryType.TRAINING, EntryType.ADJUSTEMENTS, EntryType.EXPENSES
        ];

        if(this.caller.getTransactionSystem() == 'VN'){
            selectableIdEntryTypes  = [
                EntryType.COMMISSION, EntryType.CONSULTING_BASE, EntryType.BONUS, EntryType.TIPS,
                EntryType.HOSTING, EntryType.TRAINING, EntryType.ADJUSTEMENTS, EntryType.EXPENSES
            ];
        }

        let selectableIdItemTypes = this.getItemTypeIdsToInclude();
        itemTypes = itemTypes.filter(function(value, index, arr){
            return selectableIdItemTypes.indexOf(value.id) > -1;
        });

        if(selectedAccount == 4){

            accountOptions = allAccounts.filter((account) => account.id == 4);

            if(this.caller.getTransactionSystem() == 'VN'){
                selectableIdEntryTypes = [
                    EntryType.CONSULTING_BASE, EntryType.BONUS, EntryType.TRAINING,
                    EntryType.ADJUSTEMENTS, EntryType.BENEFITS
                ];
            }else{
                selectableIdEntryTypes = [
                    EntryType.BONUS, EntryType.TRAINING, EntryType.ADJUSTEMENTS
                ];
            }
            //Current
            selectableIdItemTypes = [
                ItemType.SOCIAL_MEDIA_CONTENT,
                ItemType.CONTENT_RESEARCH,
                ItemType.TIME_PERIOD,
                ItemType.ADJUSTMENTS
            ];

            //This is in here since the itemTypes already has all the itemTypes for when it's not payroll
            itemTypes = itemTypes.filter(function(value, index, arr){
                return selectableIdItemTypes.indexOf(value.id) > -1;
            });
        }

        entryTypes = entryTypes.filter(function(value, index, arr){
            return selectableIdEntryTypes.indexOf(value.id) > -1;
        });

        this.setAccounts(accountOptions);
        this.setEntryTypeOptions(entryTypes);
        this.setItemTypes(itemTypes);

        this.setSelectedItemType(null);
        this.setSelectedEntryType(null);

        this.getTemplateViewModel().disableEntryTypes(false);
        this.getTemplateViewModel().disableItemType(this.getTemplateViewModel().idEntryType() == null || this.getTemplateViewModel().idEntryType() == undefined);
    }

    public setSelectedRole(selectedRole: number) {

        this.getTemplateViewModel().idRole(selectedRole);
    }

    public setSelectedItemType(selectedItemType: number) {

        this.getTemplateViewModel().idItemType(selectedItemType);
    }

    public setIsEdit(isEdit: boolean) {

        this.getTemplateViewModel().isEdit(isEdit);
    }

    public setSelectedChannel(selectedChannel: number) {

        this.getTemplateViewModel().idChannel(selectedChannel);
    }

    public setSelectedCurrency(selectedCurrency: number) {
        let currencyName = this.getTemplateViewModel().options_currencies().find(item => item.id === selectedCurrency).currency;
        this.getTemplateViewModel().currency(currencyName);
        this.getTemplateViewModel().idCurrency(selectedCurrency);
    }

    public setSelectedStatus(selectedStatus: number) {
        // if (selectedStatus == 2) {
        //     selectedStatus = 1;
        // }
        this.getTemplateViewModel().idStatus(selectedStatus);
    }

    public setSelectedPayment(payment: { id: number, datePaid: string, dateExecution: string }): void {

        if (payment) {
            this.getTemplateViewModel().paymentDate(payment.datePaid);
            this.getTemplateViewModel().idPayment(payment.id);
        } else {
            this.getTemplateViewModel().idPayment("");
        }
    }


    public setIsPaid() {
        this.getTemplateViewModel().isPaid(true);
    }

    public setInfoTitle(title) {
        this.getTemplateViewModel().infoTitle(title);
    }


    protected onChangeChannel() {
        this.filterRoles();
    }

    //
    // user auto complete functions
    //
    protected onBlurUser(data, event) {
        this.getTemplateViewModel().user(data.valnet_user.fullNameAndLogin)
        this.getTemplateViewModel().currency(data.valnet_paymentInfo.currency.currency);
        this.getTemplateViewModel().idCurrency(data.valnet_paymentInfo.currency.id);
        this.getTemplateViewModel().idUser(data.id);
        this.getTemplateViewModel().isShowUserSuggestions(false);

        this.getTemplateViewModel().disableAccount(false);

        let effectiveDateString = data.effectiveDate;
        let accounts = this.getTemplateViewModel().options_all_accounts();

        this.limitBrandByCompany(data);

        if(effectiveDateString != null){

            var today = new Date();
            today.setHours(0,0,0,0);
            let effectiveDate = new Date(effectiveDateString);

            if(data.idPaymentClassification == 2 && effectiveDate <= today){

                accounts = accounts.filter(function(value, index, arr){
                    return value.id == 4;
                });

                this.setAccounts(accounts);
                this.setSelectedAccount(4);
                this.getTemplateViewModel().disableAccount(false);
                return;
            }
        }

        //This only executes if the payment classification check fails, otherwise it will return before getting here.
        accounts = accounts.filter(function(value, index, arr){
            return value.id != 4;
        });
        this.setAccounts(accounts);
        this.setSelectedAccount(null);
    }

    protected limitBrandByCompany(user){

        let availableBrands = this.getTemplateViewModel().allBrands();

        if(user && user.idCompany){
            availableBrands = availableBrands.filter(function (value) {

                return value.idCompany == user.idCompany;
            });
        }else{
            availableBrands = [];
        }

        this.setBrandOptions(availableBrands);
    }

    protected onBlurDataListUser(val, list, id) {

        let found = false;
        let idCurrency = null;

        if (val() != "") {

            for (let c of list()) {

                if (c.valnet_user.fullNameAndLogin == val()) {

                    found = true;
                    id(c.id);
                    idCurrency = c.valnet_paymentInfo.idCurrency;
                    break;
                }
            }
        }

        if (!found) {

            id();
            val("");
        }
        if (found) {
            let currencyName = this.getTemplateViewModel().options_currencies().find(item => item.id === idCurrency).currency;
            this.getTemplateViewModel().currency(currencyName);
            this.getTemplateViewModel().idCurrency(idCurrency);
        }
    }

    protected onBlurArticle(data, event)
    {

        this.getTemplateViewModel().article(data.title)
        this.getTemplateViewModel().idItem(data.id);
        this.getTemplateViewModel().isShowArticleSuggestions(false);

        if(this.getTemplateViewModel().idItemType() == 9){
            this.caller.getArticleRepublishes(data.id);
        }
    }

    protected onBlurOutreachArticle(data, event) {
        this.getTemplateViewModel().outreachArticle(data.title)
        this.getTemplateViewModel().idItem(data.id);
        this.getTemplateViewModel().isShowOutreachArticleSuggestions(false);
    }

    protected onBlurDataListArticle() {

        let found = false;
        let idUser = null;

        if (this.getTemplateViewModel().article != "") {

            for (let c of this.getTemplateViewModel().articles()) {

                if (c.title == this.getTemplateViewModel().article()) {

                    found = true;
                    this.getTemplateViewModel().idItem(c.id);

                    for (let d of this.getTemplateViewModel().users()) {

                        if (d.id == c.author.id) {
                            this.getTemplateViewModel().idUser(d.id);
                            this.getTemplateViewModel().user(d.valnet_user.fullNameAndLogin);

                            let currencyName = this.getTemplateViewModel().options_currencies().find(item => item.id === d.valnet_paymentInfo.idCurrency).currency;
                            this.getTemplateViewModel().currency(currencyName);
                            this.getTemplateViewModel().idCurrency(d.valnet_paymentInfo.idCurrency);
                            break;
                        }
                    }
                    break;
                }
            }
        }

        if (!found) {

            this.getTemplateViewModel().idItem();
            this.getTemplateViewModel().article("");
        }
    }

    public onUpdateError(message: any): void {
        this.validationsList.setSingleMessage(message);
    }

    protected onChangeUserInput(event) {
        let input = event.target;
        let inputWrapper = input.parentNode;
        // let closeBtn = inputWrapper.querySelector('#user-input-close');
        // if (!closeBtn.classList.contains('is-showing')) {
        //     closeBtn.classList.add('is-showing');
        // }
        this.getTemplateViewModel().isShowArticleSuggestions(false);
        this.onChangeUserDataListUser(event, this.getTemplateViewModel().idUser);
    }

    protected onChangeUserDataListUser(event, idUser) {
        let input = event.target,
            inputVal = input.value,
            optionsList = input.getAttribute('list'),
            options: any = document.getElementById(optionsList).childNodes;

        if (inputVal.length >= 3 && event.inputType != undefined) {
            this.caller.getUsersSuggestion(inputVal);
            this.getTemplateViewModel().isShowUserSuggestions(true);
        }

        for (let op of options) {
            if (op.value === inputVal) {
                idUser(op.id);
                input.blur();
                // this.caller.filterSimpleOnChange();
                break;
            }
        }
    }

    protected onChangeArticleInput(event) {
        let input = event.target;

        this.getTemplateViewModel().isShowArticleSuggestions(false);
        this.onChangeArticleDataListUser(event, this.getTemplateViewModel().idItem);
    }

    protected onChangeOutreachArticleInput(event) {
        let input = event.target;

        this.getTemplateViewModel().isShowOutreachArticleSuggestions(false);
        this.onChangeOutreachArticleDataListUser(event, this.getTemplateViewModel().idItem);
    }

    protected onChangeArticleDataListUser(event, idItem) {
        let input = event.target,
            inputVal = input.value,
            optionsList = input.getAttribute('list'),
            options: any = document.getElementById(optionsList).childNodes;

        if (inputVal.length >= 3 && event.inputType != undefined) {
            this.caller.getArticlesSuggestion(inputVal);
            this.getTemplateViewModel().isShowArticleSuggestions(true);
        }

        for (let op of options) {
            if (op.value === inputVal) {
                idItem(op.id);
                input.blur();
                // this.caller.filterSimpleOnChange();
                break;
            }
        }
    }

    protected onChangeOutreachArticleDataListUser(event, idItem) {
        let input = event.target,
            inputVal = input.value,
            optionsList = input.getAttribute('list'),
            options: any = document.getElementById(optionsList).childNodes;

        if (inputVal.length >= 3 && event.inputType != undefined) {
            this.caller.getOutreachArticlesSuggestion(inputVal);
            this.getTemplateViewModel().isShowOutreachArticleSuggestions(true);
        }

        for (let op of options) {
            if (op.value === inputVal) {
                idItem(op.id);
                input.blur();
                // this.caller.filterSimpleOnChange();
                break;
            }
        }
    }

    public setIsBrandSelectorShown(isBrandSelectorShown) {

        // if(this.getTemplateViewModel().isBrandSelectorShown()) {
        this.getTemplateViewModel().isBrandSelectorShown(isBrandSelectorShown);
        // }
    }

    public setArticleRepublishes(articleRepublishes: Array<any>) {

        this.getTemplateViewModel().options_republishes(articleRepublishes);
    }

    public setRepublishArticle(articles: Array<any>){

        this.getTemplateViewModel().article(articles[0].title)
    }

    public onClickFillBrandSplit() {

        this.caller.getSplitsByRevenue();
    }

    public onChangeResetBrandSplit() {}

    public setCreator(creator: string): void {

        this.getTemplateViewModel().creator(creator);
    }


    public getTransactionPeriod() {
        return this.transactionTimePeriod.getFilters();
    }

    public getPeriodForSplit() {
        return this.splitTimePeriod.getFilters();
    }

    public setTransactionPeriod(transactionPeriod): void {

        this.transactionTimePeriod.setSelectedYear(transactionPeriod.year);
        this.transactionTimePeriod.setSelectedQuarter(transactionPeriod.quarter);
        this.transactionTimePeriod.setSelectedMonth(transactionPeriod.month);
        this.transactionTimePeriod.setSelectedMonthType(transactionPeriod.monthType);
    }

    public enableSplitButtonCall(enable: boolean): void {

        this.getTemplateViewModel().enableSplitButton(enable);
    }

    public getItemTypeIdsToInclude(selectedItemType?: number):Array<number> {

        let idBrand = this.caller.getTransactionSystem();

        let allowedItemTypes = [
            ItemType.ARTICLE_CONTENT, ItemType.OUTREACH_CONTENT, ItemType.SOCIAL_MEDIA_CONTENT,
            ItemType.CONTENT_RESEARCH, ItemType.ADJUSTMENTS, ItemType.TLDR_CONTENT, ItemType.REPUBLISH,
            ItemType.VIDEO_CONTENT, ItemType.ARTICLE_GROUP, ItemType.PURCHASES,
            ItemType.TRAVEL_MEALS_ENTERTAINMENT, ItemType.DIRECT_DEAL
        ];

        if (idBrand == 'VN') {
            allowedItemTypes = [
                ItemType.SOCIAL_MEDIA_CONTENT, ItemType.CONTENT_RESEARCH, ItemType.TIME_PERIOD,
                ItemType.ADJUSTMENTS, ItemType.VIDEO_CONTENT, ItemType.PURCHASES,
                ItemType.TRAVEL_MEALS_ENTERTAINMENT, ItemType.DIRECT_DEAL
            ];
        }

        // add a selected item type to allowed ones on already existing transaction.
        if (selectedItemType) {
            allowedItemTypes.push(selectedItemType);
        }

        return allowedItemTypes;
    }


    public setEntryTypeRules(data){
        this.getTemplateViewModel().entryTypesRules(data)
    }

    private onEntryTypeChange({disableItemType, entryTypesRules, idEntryType, idItemType ,options_itemTypes, options_itemTypes_clone}): any {
        disableItemType(idEntryType() == undefined)
        if(idEntryType() == undefined) idItemType(undefined)

        if (idEntryType() != undefined) {
            const rules = entryTypesRules()[idEntryType()]
            const filteredOptions_itemTypes = options_itemTypes_clone().filter(function (item) {
                if (rules == undefined) {
                    return options_itemTypes_clone()
                }
                return rules.includes(item.id)
            },)
            options_itemTypes(filteredOptions_itemTypes)
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/transactionsEdit_template.ts